module.exports = __webpack_public_path__ + "img/products_tab_icon2.4efbec96.png";